'use strict';

function handlePostUpdate(messageType, message) {
    if ($('.update-messages').length === 0) {
        $('body').append(
            '<div class="update-messages"></div>'
        );
    }

    $('.update-messages').append(
        '<div class="alert ' + messageType + ' data-updated text-center" role="alert">' +
        message +
        '</div>'
    );

    setTimeout(function () {
        $('.data-updated').remove();
    }, 5000);
}

$(document).ready(function () {

    if (sessionStorage.getItem('contactUsConfirmationMessage')) {
        handlePostUpdate('alert-dark', 'Thank you for contacting us.');
        sessionStorage.removeItem('contactUsConfirmationMessage');
    }

    // Stricter than the native type="email" check (which accepts TLD-less values like a@b)
    var emailRegex = /^[\w.%+-]+@[\w.-]+\.[a-zA-Z]{2,}$/;

    $('body').on('submit', 'form.contactUsForm', function (e) {
        var $email = $(this).find('#email');
        if (!emailRegex.test($email.val().trim())) {
            e.preventDefault();
            $email.addClass('is-invalid').focus();
            return false;
        }
        if (window.grecaptcha && window.grecaptcha.getResponse() === '') {
            e.preventDefault();
            $(this).find('.g-recaptcha').addClass('is-invalid');
            return false;
        }
        sessionStorage.setItem('contactUsConfirmationMessage', true);
        return true;
    });

    $('body').on('input', 'form.contactUsForm #email', function () {
        $(this).removeClass('is-invalid');
    });

    window.contactUsRecaptchaCallback = function () {
        $('form.contactUsForm .g-recaptcha').removeClass('is-invalid');
    };
});
